<template>
  <div>
    <ValidationDialog :ShowModal="ShowModal" :RouteUrl="RouteUrl" :DisplayMessage="DisplayMessage"></ValidationDialog>
    <SenderEmailUpdateDialog :ShowModal="showEmailUpdateModal" @onemailupdated="onEmailSubmitted">
    </SenderEmailUpdateDialog>

    <div class="main-header">
      <div class="container">
        <h2 class="main-header-text">Transaction History</h2>
      </div>
    </div>
    <!-- eo main header -->


    <div class="main-section mgt-40">
      <div class="container">

        <div class="main-card">
          <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

          <form @submit.prevent="onFilterFormSubmit" novalidate="" autocomplete="off"
            data-vv-scope="externalFilterForm">
            <h2 class="section-heading">Filter Transaction</h2>
            <hr />
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>From Date</label>
                  <kendo-datepicker v-model="externalFilterViewModel.FromDate" :format="'yyyy/MM/dd'"
                    v-validate=" externalFilterViewModel.ToDate !='' ? 'required' : ''"
                    :class="{'input': true, 'is-danger': errors.has('externalFilterForm.FromDate') }"
                    class="form-control" name="FromDate" data-vv-as="from date" onkeydown="return false;">
                  </kendo-datepicker>
                  <div v-show="errors.has('externalFilterForm.FromDate')" class="help is-danger">
                    {{ errors.first('externalFilterForm.FromDate') }}</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To Date</label>
                  <kendo-datepicker v-model="externalFilterViewModel.ToDate" :format="'yyyy/MM/dd'"
                    v-validate="externalFilterViewModel.FromDate !='' ? 'required' : ''"
                    :class="{'input': true, 'is-danger': errors.has('externalFilterForm.ToDate') }" class="form-control"
                    name="ToDate" data-vv-as="to date" onkeydown="return false;"></kendo-datepicker>
                  <div v-show="errors.has('externalFilterForm.ToDate')" class="help is-danger">
                    {{ errors.first('externalFilterForm.ToDate') }}</div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>
                    Country
                  </label>
                  <kendo-dropdownlist name='CountryId' v-if="CountryCollection!=null" class="form-control"
                    v-model="externalFilterViewModel.PayoutCountryId" :data-text-field="'Text'" :data-value-field="'Id'"
                    :option-label="'Please Select Country'" :auto-bind="true" :data-source="CountryCollection" :filter="'startswith'"
                    :data-value-primitive="true"> 
                  </kendo-dropdownlist>

                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>
                    Transaction Reference
                  </label>
                  <input autocomplete="off" v-model="externalFilterViewModel.TransactionRefNo" type="text"
                    class="form-control" />

                </div>
              </div>
            </div>

            <div class="row m-b-lg m-t-sm">
              <div class="col-sm-12">
                <button class="btn btn-red btn-lg btn-history">Submit</button>
                <button class="btn btn-gray btn-lg btn-history" type="button" @click="onCancelFilter">Cancel</button>
              </div>
            </div>
          </form>
          <hr class="m-b-lg" />
          <kendo-grid :data-source="kendoDataSource" :pageable='true' :sortable='true' :pagable='pageable'
            :columns="columns" :no-records="true" :filterable='filterable' @databound="onDataBound">
          </kendo-grid>



        </div>
        <!-- eo main card -->

      </div>
      <!-- eo container -->
    </div>
    <!-- eo main section -->

  </div>


</template>
<script>
  import Base from "../../shared/Base.vue";
  import ListService from "../../services/list";
  import kendo from "@progress/kendo-ui";
  import ValidationDialog from "../../shared/ValidationDialog.vue";
  import SenderEmailUpdateDialog from "../../shared/SenderEmailUpdate.vue";
  import moment from 'moment';
  export default {
    name: "transactionHistory",
    extends: Base,
    components: {
      ValidationDialog,
      SenderEmailUpdateDialog
    },
    created() {
      this.url.list = 'transaction/list'

      if (kendo.ExternalFilter)
          delete kendo.ExternalFilter;
    },
    data() {
      return {
        show: false,
        CountryCollection: null,
        Banks: null,
        externalFilter: true,
        RefundViewModel: {

          TransactionRefNo: '',
          RefundRemark: '',
          FullName: '',
          Amount: '',
          Remark: '',
          AccountNumber: null,
          AccountHolder: null,
          BankId: null
        },
        externalFilterViewModel: GetDefaultModel(),
        ShowModal: false,
        RouteUrl: null,
        DisplayMessage: '',
        showEmailUpdateModal: false,
        showBeneModal: false,
        PayoutModeId: null,
        BeneficiaryId: null,
        TransactionRefNo: null,
        columns: [{
          title: 'Transaction Reference',
          template: function (data) {
            return '<img src="' + data.TransactionChannelImageUrl + '" height="25" width="25"> <a id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-txndetail kendo-url" ><span class="txn-link" data-transactionrefno="' + data.TransactionRefNo + '">' + data.TransactionRefNo + '</span></a><br/><span class="recipient-caption">' + data.FullName + '</span>'
          }
        },
        {
          title: 'Send Amount >  Pay Amount',
          template: function (data) {
            return data.SCurrency + ' ' + data.SendAmount.toFixed(2) + ' > ' + data.PCurrency + ' ' + data.PayoutAmount.toFixed(2)
          }
        },
        {
          title: 'Created On',
          field: 'CreatedDate',
          filterable: false
        },

        {
          title: 'Status',
          width: 300,
          template: function (data) {
            if (data.StatusId == 9) {
                return '<a  id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-reprocess d-inline p-2 bg-danger  text-white kendo-url round-btn" ><i data-transactionrefno="' + data.TransactionRefNo + '" data-beneficiaryid="' + data.BeneficiaryId + '" data-typeoftransaction="' + data.TypeofTraxId + '" >Reprocess</i></a>';
            }
            else if (data.StatusId == 12) {
              return '<a id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-refund d-inline p-2 bg-danger  text-white kendo-url round-btn" ><i data-transactionrefno="' + data.TransactionRefNo + '" data-fullname="' + data.FullName + '" data-refundamount="' + data.RefundAmount + '" data-refundremark="' + data.RefundRemark + '" >' + data.CustomerStatus + '</i></a>';
            }
            else if (data.StatusId == 10) {
              return '<i class="d-inline p-1 bg-secondary  text-white round-btn">' + data.CustomerStatus + '</i> <br/><br/><a id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-transactionrefno kendo-url" ><a id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-txndetail kendo-url" ><i data-transactionrefno="' + data.NewTransactionRefNo + '">' + data.NewTransactionRefNo + '</i></a>'
            }
            else if (data.StatusId == 13) {
              return '<i class="d-inline p-1 bg-secondary  text-white round-btn">' + data.CustomerStatus + '</i>'
            }
            else if (data.StatusId == 25 || data.CustomerStatus == 'Booking Expired') {
              pClass = "bg-danger";
              var htmlString = '<i class="d-inline p-2 ' + pClass + '  text-white round-btn">' + data.CustomerStatus + '</i>';
              if (data.ResendApplicable) {
                htmlString += '<i class="vue-kendo-link-resend d-inline p-2 resendBtn text-red round-btn" data-transactionrefno="' + data.TransactionRefNo + '" data-typeoftransaction="' + data.TypeofTraxId + '" data-beneficiaryid="' + data.BeneficiaryId + '">Resend</i>';
              }
              return htmlString;
            }
            else if (data.StatusId == 26) {
              return '<a  id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-amend d-inline p-2 bg-danger  text-white kendo-url round-btn" ><i data-transactionrefno="' + data.TransactionRefNo + '" data-beneficiaryid="' + data.BeneficiaryId + '" data-typeoftransaction="' + data.TypeofTraxId + '" >Amend</i></a>' +
                '<a id="edit-' + data.TransactionRefNo + '" class="vue-kendo-link-refund d-inline p-2 bg-danger  text-white kendo-url round-btn" ><i data-transactionrefno="' + data.TransactionRefNo + '" data-fullname="' + data.FullName + '" data-refundamount="' + data.RefundAmount + '" data-refundremark="' + data.RefundRemark + '" >Refund</i></a>';
            }
            else {
              var pClass = "bg-warning";

              if (data.StatusId == 5)
                pClass = "bg-success";
              else if (data.StatusId == 27)
                pClass = "bg-danger";

              var htmlString = '<i class="d-inline p-2 ' + pClass + '  text-white round-btn">' + data.CustomerStatus + '</i>';
              if (data.ResendApplicable) {
                htmlString += '<i class="vue-kendo-link-resend d-inline p-2 resendBtn text-red round-btn" data-transactionrefno="' + data.TransactionRefNo + '" data-typeoftransaction="' + data.TypeofTraxId + '" data-beneficiaryid="' + data.BeneficiaryId + '">Resend</i>';
              }
              return htmlString;
            }
          }
        },
        ]
      }
    },
    beforeRouteEnter(to, from, next) {
      var promises = [];
      promises.push(ListService.getCountry(), ListService.getRefundBank());
      Promise.all(promises).then(Response => {
        next(p => {
          p.CountryCollection = Response[0].body;
          p.Banks = Response[1].body;
        });
      });
    },
    methods: {
      OnOkSubmit(evt) {

        evt.preventDefault()
        this.onRefundSubmit();
      },
      onRefundCancel() {
        this.errors.clear('refundForm')
      },
      onRefundSubmit() {

        var self = this;
        if (self.isProcessing)
          return;

        self.$validator.validateAll('refundForm').then(result => {

          if (result) {
            self.isProcessing = true;
            self.$http.post("transaction/refund/process", self.RefundViewModel).then(
              response => {
                self.$toastr("success", "Refund successfully");
                self.isProcessing = false;
                this.refreshKendoDataSource();
                this.show = false;

              },
              error => {
                self.isProcessing = false;
              }
            );


          }
        });
      },
      beforeSave() {
        return true;
      },
      onEdit(event) {
        this.$router.push("/transaction/detail/" + event.target.dataset.transactionrefno);
      },
      onRefund(event) {

        this.$router.push("/transaction/refund/" + event.target.dataset.transactionrefno);
        /* console.log(event.target.dataset)
         this.errors.clear('refundForm')
         this.show = true;
         var dataSet = event.target.dataset;
         this.RefundViewModel.TransactionRefNo = dataSet.transactionrefno;
         this.RefundViewModel.RefundRemark = dataSet.refundremark;
         this.RefundViewModel.FullName = dataSet.fullname;
         this.RefundViewModel.Amount = dataSet.refundamount;*/
      },
      onReprocess(event) {
        var dataSet = event.target.dataset;
        this.$router.push("/recipient/merchantrade/edit/" + dataSet.typeoftransaction + "/" + dataSet.beneficiaryid + "/" + dataSet.transactionrefno);
      },
      onResend(event) {
        var self = this;
        event.preventDefault();
        var dataSet = event.target.dataset;
        self.PayoutModeId = dataSet.typeoftransaction;
        self.BeneficiaryId = dataSet.beneficiaryid;
        self.TransactionRefNo = dataSet.transactionrefno;
        var model = {
          PayoutModeId: dataSet.typeoftransaction,
          BeneficiaryId: dataSet.beneficiaryid
        }
        window.Vue.$http.post("transaction/beneficiary/isvalid", model).then(response => {
          if (response.body) {
            if (response.body.IsSenderEmailRequired && response.body.IsValid) {
              self.showEmailUpdateModal = true;

            } else if (response.body.IsSenderEmailRequired && !response.body.IsValid) {
              self.showEmailUpdateModal = true;
              self.showBeneModal = true;
              self.DisplayMessage = response.body.DisplayMessage;
              self.RouteUrl = model.PayoutModeId == 97 || model.PayoutModeId == 98 ? "/recipient/westernunion/edit/" + model.BeneficiaryId : "/recipient/merchantrade/edit/" + model.PayoutModeId + "/" + model.BeneficiaryId;

            } else if (!response.body.IsSenderEmailRequired && !response.body.IsValid) {
              self.ShowModal = true;
              self.DisplayMessage = response.body.DisplayMessage;
              self.RouteUrl = model.PayoutModeId == 97 || model.PayoutModeId == 98 ? "/recipient/westernunion/edit/" + model.BeneficiaryId : "/recipient/merchantrade/edit/" + model.PayoutModeId + "/" + model.BeneficiaryId;

            } else {
              self.$router.push("/transaction/" + dataSet.beneficiaryid + "/" + dataSet.typeoftransaction + "/" + dataSet.transactionrefno);
            }
          }

        },
          error => {

          }
        )

      },
      onTxnDetail(event) {
        var dataSet = event.target.dataset;
        this.$router.push("/transaction/detail/" + dataSet.transactionrefno);
      },
      onAmend(event) {
        var dataSet = event.target.dataset;
        this.$router.push("/transaction/amend/" + dataSet.transactionrefno);
      },
      onDataBound: function (ev) {

        this.kendoGrid = ev.sender;
        this.editButtons = document.body.querySelectorAll(".vue-kendo-link-refund");
        this.editButtons.forEach(el => {
          el.addEventListener("click", this.onRefund);
        });

        this.deleteButtons = document.body.querySelectorAll(".vue-kendo-link-reprocess");
        this.deleteButtons.forEach(el => {
          el.addEventListener("click", this.onReprocess);
        });

        this.sendButtons = document.body.querySelectorAll(".vue-kendo-link-resend");
        this.sendButtons.forEach(el => {
          el.addEventListener("click", this.onResend);
        });

        document.body.querySelectorAll(".vue-kendo-link-txndetail").forEach(el => {
          el.addEventListener("click", this.onTxnDetail);
        });

        document.body.querySelectorAll(".vue-kendo-link-amend").forEach(el => {
          el.addEventListener("click", this.onAmend);
        });
      },
      onCancelFilter() {
        var self = this;
        self.vModel = GetDefaultModel();
        if (kendo.ExternalFilter) delete kendo.ExternalFilter;
        self.refreshKendoDataSource();
        self.externalFilterViewModel = GetDefaultModel();
      },
      onFilterFormSubmit(){
        var self = this;
        self.externalFilterViewModel.FromDate = self.externalFilterViewModel.FromDate ? moment(self.externalFilterViewModel.FromDate).format('YYYY-MM-DD') : '';
        self.externalFilterViewModel.ToDate = self.externalFilterViewModel.ToDate ? moment(self.externalFilterViewModel.ToDate).format('YYYY-MM-DD') : '';
        self.onExternalFilterSubmit();
      },
      onEmailSubmitted() {
        var self = this;
        if (self.showBeneModal)
          self.ShowModal = self.showBeneModal;
        else
          self.$router.push("/transaction/" + self.BeneficiaryId + "/" + self.PayoutModeId + "/" + self.TransactionRefNo);
      }
    }
  };

  function GetDefaultModel() {
    return {
      FromDate: '',
      ToDate: '',
      PayoutCountryId: '',
      TransactionRefNo: ''
    };
  }

</script>

<style>
  .resendBtn {
    color: red;
    border: 2px solid;
  }
  .btn-history{
  background: ButtonFace;
  margin-right: 10px;
  }
</style>
